export const renderStatusConst = (status) => {
  switch (status) {
    case 0:
      return <span className="tag tag-inReview">In Review</span>;
    case 1:
      return <span className="tag tag-approved">Approved</span>;
    case 2:
      return <span className="tag tag-denied">Denied</span>;
    case 3:
  }
};
